import addUrgencyApi from '@custom/rtk-apis/billing/urgency/addUrgency';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const addUrgencySlice = createSlice({
  name: 'addUrgencySlice',
  initialState,
  reducers: {
    clearAddUrgency: (state) => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUrgencyApi.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(addUrgencyApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.msg = payload.msg || '';
        state.result = payload.result || null;
      })
      .addCase(addUrgencyApi.rejected, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status || 'error';
        state.msg = payload?.msg || 'An unexpected error occurred.';
        state.error = payload?.msg || 'Failed to add urgency case';
      });
  },
});

export default addUrgencySlice.reducer;
export const { clearAddUrgency } = addUrgencySlice.actions;
